/* eslint-disable no-dupe-keys */
export default {
  post: {
    name: '文章',
    // 属性（一般与对象内容匹配）
    prop: {
      title: '标题',
      content: '内容',
      status: '状态',
      author: '作者',
      tag: '标签',
      resolved: '已解决',
      unresolved: '未解决',
      created_at: '创建时间',
      updated_at: '更新时间',
      webapp_page: '预览地址',
      seo_uri: 'SEO URI'
    },
    button: {
      stick: '置顶',
      unstick: '取消置顶'
    },
    feedbacks: {
      unresolved_reason: '标记类别',
      additional_note: '备注内容',
      user: '用户',
      created_at: '创建时间'
    },
    // Enum的属性
    statuses: {
      disabled: '关闭',
      enabled: '开放'
    },
    list_tabs: {
      all: '全部',
      customer_service: '客服咨询'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询标题'
    },
    //类型
    tag: {
      normal: '普通文章',
      customer_service: '客服咨询'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      feedbacks: '意见反馈'
    },
    titles: {
      base_info: '基础信息'
    },
    tips: {
      copy_success: '已复制预览地址: ',
      copy_fail: '无法复制内容，请手动复制编号',
      stick_success: '置顶成功',
      unstick_success: '取消置顶成功'
    }
  }
}
